import { useEffect } from 'react';
import { clearEventPageWs, ensureEventPageWsLoaded } from './store';

export const useEventPageWsConnection = (eventId: number) => {
  useEffect(() => {
    if (!eventId) return;

    clearEventPageWs();
    ensureEventPageWsLoaded({ eventId });

    return () => {
      clearEventPageWs();
    };
  }, [eventId]);
};
